import * as bootstrap from "bootstrap/dist/js/bootstrap.esm";
window.bootstrap = bootstrap;
require("bootstrap-select");

// bootstrap-select 默认文案为英文，根据页面 locale 提供本地化文案
const selectLocaleTexts = {
  zh_cn: {
    noneSelectedText: "没有选中任何项",
    noneResultsText: "没有找到匹配结果",
  },
};

document.addEventListener("turbolinks:load", () => {
  const metaLocale = document.querySelector('meta[name=locale]');
  const lang = ((metaLocale && metaLocale.content) || 'en').replace('-', '_').toLowerCase();

  $("select.bootstrap-select").selectpicker({
    size: 10,
    style: "btn-secondary",
    ...(selectLocaleTexts[lang] || {}),
  });
});
document.addEventListener("turbolinks:before-cache", () => {
  $("select.bootstrap-select")
    .selectpicker("destroy")
    .addClass("bootstrap-select");
});
